var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "record-picker-tabs",
    attrs: {
      "role": "tablist",
      "aria-label": _vm.ariaLabel
    }
  }, [_c('button', {
    staticClass: "record-picker-tab",
    "class": {
      active: _vm.value === 'registered'
    },
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.value === 'registered' ? 'true' : 'false'
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('input', 'registered');
      }
    }
  }, [_vm._v(" Evidované "), _c('span', {
    staticClass: "record-count"
  }, [_vm._v(_vm._s(_vm.registeredCount))])]), _c('button', {
    staticClass: "record-picker-tab add-new",
    "class": {
      active: _vm.value === 'new'
    },
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.value === 'new' ? 'true' : 'false'
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('input', 'new');
      }
    }
  }, [_c('span', {
    staticClass: "add-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("+")]), _vm._v(" Pridať nový ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }